import { useRef } from 'react';

import { useMeterBarToolbarConfig } from '../context/MeterBarToolbarConfigContext.js';

export const useMeterBarChartToolbar = () => {
  const toolbarRef = useRef<HTMLDivElement>(null);
  const toolbarConfig = useMeterBarToolbarConfig();
  const isToolbarEnabled =
    !toolbarConfig?.hidden && !!toolbarConfig?.intents?.length;

  const modifyHoverState = (hoverState: boolean) => {
    if (isToolbarEnabled) {
      if (hoverState) {
        toolbarRef.current?.showPopover();
      } else {
        toolbarRef.current?.hidePopover();
      }
    }
  };

  return {
    toolbarRef,
    isToolbarEnabled,
    modifyHoverState,
  };
};
